import { render, staticRenderFns } from "./RoadmapDesynchronizationSettings.vue?vue&type=template&id=c2937112&scoped=true&"
import script from "./RoadmapDesynchronizationSettings.vue?vue&type=script&lang=js&"
export * from "./RoadmapDesynchronizationSettings.vue?vue&type=script&lang=js&"
import style0 from "./RoadmapDesynchronizationSettings.vue?vue&type=style&index=0&id=c2937112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2937112",
  null
  
)

export default component.exports